export default __webpack_public_path__ + "static/media/floristAssistant.7f057775.svg";